import React from "react";
import ReactDOM from "react-dom";
import {HashRouter, Route, Switch, Redirect} from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import 'antd/dist/antd.css';
import "assets/font/fonts.css";
import "assets/font/iconfont.css";
import "assets/styles/tailwind.css";
import 'assets/styles/tailwindAddition.scss';
import 'assets/styles/main.scss';
import 'assets/styles/overwrite.scss';
import 'assets/styles/theme.scss';

import Burnt from "layouts/Burnt";

import { ContextProvider } from "./reducer";
import Inter from "./locale/intl";

ReactDOM.render(
  <ContextProvider>
    <Inter>
      <HashRouter>
        <Switch>
          <Route path="/" component={Burnt} />
          <Redirect from="*" to="/nftburnt" />
        </Switch>
      </HashRouter>
    </Inter>
  </ContextProvider>,
  document.getElementById("root")
);
